import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { ConstantsService } from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { AuthResponse } from 'src/app/shared/models/api-response/auth-response';
import { Service } from 'src/app/shared/models/service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	username = '';
	password = '';

	alerts: any[] = [];
	wrongCredentialMessage = {
		type: 'danger',
		msg: `Mot de passe ou nom d'utilisateur incorrect. Veuillez
        réessayer.`
	};

	errorMessage = {
		type: 'danger',
		msg: `Une erreur est survenue, veulliez réessayer dans
        quelques instants. Si l'erreur persiste, contactez le
        support technique.`
	};

	isTryingToLogin: boolean = false;
	listService: Service[];

	constructor(
		private authService: AuthenticationService,
		private router: Router,
		private constantsService: ConstantsService,
		private facade: FacadeService
	) {}

	ngOnInit() {
		if (this.facade.dataStorageService.getUser()) {
			if (!this.facade.dataStorageService.isIntervenant()) {
				this.router.navigateByUrl('/dashboard');
			} else {
				this.router.navigateByUrl('/planning');
			}
		}
		
	}

	//private refreshTokenTimeout?: NodeJS.Timeout;

    // private startRefreshTokenTimer(username: string, refreshToken: string) {
    //     this.refreshTokenTimeout = setTimeout(() => this.facade.authenticationService.refreshToken(username, refreshToken).subscribe({
	// 		next: (resp: AuthResponse) =>{
	// 			console.log('timeout stated');
	// 			this.facade.dataStorageService.setJwtToken(resp.jwtToken);
	// 			this.facade.dataStorageService.setRefreshToken(resp.refreshToken);
	// 			this.startRefreshTokenTimer(resp.user.username, resp.refreshToken);
	// 		}
	// 	}), (2 * 59 * 60 * 1000));
    // }

    // private stopRefreshTokenTimer() {
    //     clearTimeout(this.refreshTokenTimeout);
    // }

	signIn() {
		this.alerts = [];
		this.isTryingToLogin = true;
		this.authService.authenticate(this.username, this.password).subscribe({
			next: (resp: AuthResponse) => {
				//this.logger.log('authenticate response : ', resp);
				console.log(resp);

				this.facade.dataStorageService.setJwtToken(resp.jwtToken);
				this.facade.dataStorageService.setRefreshToken(resp.refreshToken);
				this.facade.dataStorageService.setUser(resp.user);

				//this.startRefreshTokenTimer(resp.user.username, resp.refreshToken);

				if(!this.facade.dataStorageService.isIntervenant()){
					this.facade.serviceService.getServicesByUser(resp.user.id).subscribe({
						next: (val) => {
							this.listService = val;
						},
						complete: () => {
							this.facade.dataStorageService.setService(this.listService[0]);
							if(this.listService[0].regions?.length == 1){
								this.facade.dataStorageService.setRegion(this.listService[0]?.regions[0]);
							}else if(this.listService[0].regions?.length > 1){
								this.facade.regionService.getRegionsByUser(resp.user.id).subscribe({
									next: (val) => {
										this.facade.dataStorageService.setRegion(val[0]);
									}
								});
							}
							this.router.navigateByUrl('/dashboard');
						},
					});
				}else{
					this.router.navigateByUrl('/dashboard');
				}

				// this.constantsService.updateUserAuthority(resp.user.profile.id);
				// this.isTryingToLogin = false;
				// if (!this.facade.dataStorageService.isIntervenant()) {
				// } else {
				// 	this.router.navigateByUrl('/planning');
				// }
			},
			error: (errorCode) => {
				this.isTryingToLogin = false;
				if (errorCode.status === 401 || errorCode.status === 500) {
					this.alerts.push(this.wrongCredentialMessage);
				} else {
					this.alerts.push(this.errorMessage);
				}
			}
		});
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}
}
